import ProfilesListPage from "./ProfilesListPage";

export default ProfilesListPage;